import { useDebounce } from "designSystem/hooks";
import { SearchTextField } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewAttributesStore } from "./CustomViewAttributesStore";

const AttributesSearch: FunctionComponent = observer(() => {
	const attributesStore = useCustomViewAttributesStore();
	const { searchText, setSearchText, selectedLevel } = attributesStore;
	const [value, setValue] = useDebounce(searchText, setSearchText, 250, [selectedLevel]);
	const loc = useLocale();
	const onChange = (event) => setValue(event.target.value);

	return (
		<SearchTextField
			data-csi-automation="AttributesSearch"
			fullWidth
			onChange={onChange}
			placeholderRes="Search"
			value={value}
		/>
	);
});

export default AttributesSearch;